// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-0f69d46e] {\n  margin: 0;\n  padding: 0;\n}\nbody[data-v-0f69d46e] {\n  background: black;\n}\ncanvas[data-v-0f69d46e] {\n  display: block;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
